import { createUserWithEmailAndPassword, deleteUser } from "firebase/auth";
import { collection, doc, getDoc, getDocs, orderBy, query, setDoc, updateDoc, where } from "firebase/firestore";
import { auth, db } from "../config/firebase";
import { userInitialData } from "./spName";

//AuthContext : to check user by uid in firestore
export const CheckUserExist = async (uid) => {
    const d = getDoc(doc(db, 'users', uid))
    return await d.then(d => {
        if (!d.exists()) return false;
        if (!Object.keys(d.data()).length) return false
        return true
    }).catch(() => false)
}

//AuthContext : to store "owndata"
export const NewQueryUser = async (uid) => {
    try {
        const docRef = doc(db, "users", uid);
        const docSnap = await getDoc(docRef);
        if (!docSnap.exists()) throw new Error('ไม่พบเอกสาร') 
        let a = {...docSnap.data()}
        return a
    }
    catch (e) {
        console.log(e)
    }
}

//AdminContext : to store "users"
export const QueryUsersOnce = async (setUsers, onlyRound = null) => {
    try {
        let a = {}
        const q1 = onlyRound && !isNaN(onlyRound) ? query(collection(db, "users"), where('round', '==', onlyRound), orderBy('round', 'desc')) : query(collection(db, "users"), orderBy('round', 'desc'))
        const docs1 = await getDocs(q1)
        docs1.forEach(d => {
            a = {...a, [d.id] : {...d.data(), register : true}}
        })
        let sortable = [...Object.keys(a)].sort((x, y) => {
            if (a[x].round > a[y].round) {
                return -1
            }
            else if (a[x].round < a[y].round) {
                return 1
            }
            else if (["", "-", 0, false, undefined].includes(a[x].flightIndex) || isNaN(a[x].flightIndex)) {
                return 1
            }
            else if (["", "-", 0, false, undefined].includes(a[y].flightIndex) || isNaN(a[y].flightIndex)) {
                return -1
            }
            else if (!isNaN(a[x].flightIndex) && !isNaN(a[y].flightIndex)){
                let fa = parseInt(a[x].flightIndex)
                let fb = parseInt(a[y].flightIndex)
                return fa > fb ? 1 : fa < fb ? -1 : 0
            }
            else {
                //return ('' + a[x].nameEN.attr).localeCompare(a[y].nameEN.attr);
                //return (a[x].nameEN.attr > a[y].nameEN.attr) - (a[x].nameEN.attr < a[y].nameEN.attr)
                return a[x].nameEN > a[y].nameEN ? 1 : a[x].nameEN < a[y].nameEN ? -1 : 0
            }
        })
        let sortedUsers = {}
        sortable.forEach(keyname => {
            sortedUsers[keyname] = a[keyname]
        })
        setUsers(sortedUsers)
    }
    catch (e) {
        console.log(e)
    }
}

export const QueryUsersWithFilter = async (filters, onlyRound = null) => {
    try {
        let a = {}
        const q1 = getQueryItem(filters, onlyRound)
        const docs1 = await getDocs(q1)
        docs1.forEach(d => {
            a = {...a, [d.id] : {...d.data(), register : true}}
        })
        let sortable = [...Object.keys(a)].sort((x, y) => {
            if (a[x].round > a[y].round) {
                return -1
            }
            else if (a[x].round < a[y].round) {
                return 1
            }
            else if (["", "-", 0, false, undefined].includes(a[x].flightIndex) || isNaN(a[x].flightIndex)) {
                return 1
            }
            else if (["", "-", 0, false, undefined].includes(a[y].flightIndex) || isNaN(a[y].flightIndex)) {
                return -1
            }
            else if (!isNaN(a[x].flightIndex) && !isNaN(a[y].flightIndex)){
                let fa = parseInt(a[x].flightIndex)
                let fb = parseInt(a[y].flightIndex)
                return fa > fb ? 1 : fa < fb ? -1 : 0
            }
            else {
                //return ('' + a[x].nameEN.attr).localeCompare(a[y].nameEN.attr);
                //return (a[x].nameEN.attr > a[y].nameEN.attr) - (a[x].nameEN.attr < a[y].nameEN.attr)
                return a[x].nameEN > a[y].nameEN ? 1 : a[x].nameEN < a[y].nameEN ? -1 : 0
            }
        })
        let sortedUsers = {}
        sortable.forEach(keyname => {
            sortedUsers[keyname] = a[keyname]
        })
        return sortedUsers;
    }
    catch (e) {
        console.log(e)
    }
}

//PageProfile, RenderUser, AuthContext : to update an user
export const UpdateUser = async (data, uid = auth.currentUser.uid) => {
    try {
        let d = {...data}
        if (d.role && !isNaN(d.role) && typeof d.role !== 'number') d.role = parseInt(d.role)
        if (d.round && !isNaN(d.round) && typeof d.round !== 'number') d.round = parseInt(d.round)
        if (d.dose && !isNaN(d.dose) && typeof d.dose !== 'number') d.dose = parseInt(d.dose)
        if (d.food && !isNaN(d.food) && typeof d.food !== 'number') d.food = parseInt(d.food)
        const docRef = doc(db, 'users', uid)
        await updateDoc(docRef, {...d})
        
    }
    catch (e) {
        console.log(e)
    }
}

//PageDatabases : to query ALL data to csv
export const GetDataFromFirebase = async (filter, checkedItems) => {
    
    const fields = Object.keys(checkedItems).filter(v => checkedItems[v] === true)
    const q = getQueryItem(filter)
    const docs = await getDocs(q)
    let u = []
    docs.forEach(d => {
        let o = {}
        fields.forEach(f => {
            if (d.data()[f] !== undefined) {
                o = {...o, [f] : d.data()[f] !== undefined ? d.data()[f] : ''}
            }
        })
        u = [...u, o]
    })
    return u
}

//PageRegister : to check if email exist
export const CheckEmailExist = async (email) => {
    const d = await getDocs(query(collection(db, 'users'), where('email', '==', email)))
    //d.then(d1 => console.log(d1.size))
    //return await d.then(d => d.size !== 0).catch(() => false)
    return d.size !== 0
}

export const CreateNewUser = async (email, password) => {
    try {
        const u = await createUserWithEmailAndPassword(auth, email, password)
        return u.user
    }
    catch(e) {
        switch (e.code) {
            case 'auth/email-already-in-use':
                alert(`ขออภัย อีเมล ${email} นี้ถูกใช้งานแล้ว โปรดเข้าสู่ระบบแทน`);
                break;
            case 'auth/invalid-email':
                alert(`ขออภัย อีเมล ${email} ไม่ถูกต้อง`);
                break;
            case 'auth/operation-not-allowed':
                alert(`ขออภัย กรุณาติดต่อทีมงาน`);
                break;
            case 'auth/network-request-failed':
                alert(`ขออภัย โปรดตรวจสอบเครือข่ายของท่าน หากท่านอยู่ในประเทศจีน โปรดเชื่อมต่อ VPN`);
                break;
            default:
                alert(e.message);
                break;
          }
    }
}

export const AddNewUser = async (uid, email) => {
    try {
        await setDoc(doc(db, 'users', uid), {
            ...userInitialData, email
        })
        console.log(uid, email, {...userInitialData, email})
    }
    catch (e) {
        if (auth.currentUser) await deleteUser(auth.currentUser)
        alert(e.message)
    }
    
}


const getQueryItem = (filter, onlyRound = null) => {
    let w = []
    let f = {...filter}
    for (let i = 0; i < 3; i++) {
        if (f[i].field && f[i].value !== '' && f[i].value !== undefined) {
            let v = f[i].value
            if (v === 'true') v = true
            else if (v === 'false') v = false
            else if (!isNaN(v) && f[i].field !== 'flightIndex' && typeof v !== 'boolean') v = parseInt(v)
            w = [...w, { field : f[i].field, value : v}]
        }
    }
    let q;
    if (!onlyRound) {
        if (w[0] && w[0].field !== 'round' && w[1] && w[1].field !== 'round' && w[2] && w[2].field !== 'round') {
            switch (w.length) {
                case 0 : default :
                    q = query(collection(db, 'users'), orderBy('round', 'desc'))
                    break;
                case 1 :
                    q = query(collection(db, 'users'), orderBy('round', 'desc'), where(w[0].field, '==', w[0].value))
                    break;
                case 2 :
                    q = query(collection(db, 'users'), orderBy('round', 'desc'), where(w[0].field, '==', w[0].value), where(w[1].field, '==', w[1].value))
                    break;
                case 3 :
                    q = query(collection(db, 'users'), orderBy('round', 'desc'), where(w[0].field, '==', w[0].value), where(w[1].field, '==', w[1].value), where(w[2].field, '==', w[2].value))
                    break;
            }
        }
        else if ((w[0] && w[0].field === 'round' && w[0].value === 99) || (w[1] && w[1].field === 'round' && w[1].value === 99) || (w[2] && w[2].field === 'round' && w[2].value === 99)) {
            q = query(collection(db, 'users'), orderBy('round', 'desc'))
        }
        else {
            switch (w.length) {
                case 0 : default :
                    q = query(collection(db, 'users'))
                    break;
                case 1 :
                    q = query(collection(db, 'users'), where(w[0].field, '==', w[0].value))
                    break;
                case 2 :
                    q = query(collection(db, 'users'), where(w[0].field, '==', w[0].value), where(w[1].field, '==', w[1].value))
                    break;
                case 3 :
                    q = query(collection(db, 'users'), where(w[0].field, '==', w[0].value), where(w[1].field, '==', w[1].value), where(w[2].field, '==', w[2].value))
                    break;
            }
        }
        
    }
    else {
        if ((w[0] && w[0].field === 'round' && w[0].value === 99) || (w[1] && w[1].field === 'round' && w[1].value === 99) || (w[2] && w[2].field === 'round' && w[2].value === 99)) {
            q = query(collection(db, 'users'), where('round', '==', onlyRound))
        }
        else {
            switch (w.length) {
                case 0 : default :
                    q = query(collection(db, 'users'), where('round', '==', onlyRound))
                    break;
                case 1 :
                    q = query(collection(db, 'users'), where('round', '==', onlyRound), where(w[0].field, '==', w[0].value))
                    break;
                case 2 :
                    q = query(collection(db, 'users'), where('round', '==', onlyRound), where(w[0].field, '==', w[0].value), where(w[1].field, '==', w[1].value))
                    break;
                case 3 :
                    q = query(collection(db, 'users'), where('round', '==', onlyRound), where(w[0].field, '==', w[0].value), where(w[1].field, '==', w[1].value), where(w[2].field, '==', w[2].value))
                    break;
            }
        }   
    }
    return q;
}